import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-743ca6bd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "down-main"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "big-title"
}, "真实小圈   真心交友", -1));

const _hoisted_5 = {
  class: "img-main"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, "小圈约", -1));

const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"beian\" data-v-743ca6bd><div data-v-743ca6bd>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011124\" data-v-743ca6bd><span class=\"beian-color\" data-v-743ca6bd>粤公网安备 44010602011124号</span></a></div><div data-v-743ca6bd>网站备案/许可证号：<a class=\"beian-link\" target=\"_blank\" href=\"https://beian.miit.gov.cn/\" data-v-743ca6bd><span class=\"beian-color\" data-v-743ca6bd>粤ICP备2022145697号-1</span></a></div><div data-v-743ca6bd>违法和不良信息举报邮箱：<span class=\"beian-color\" data-v-743ca6bd>xqy888vip@163.com</span></div></div>", 1);

const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "tips-val"
};
const _hoisted_14 = {
  class: "share-desc"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 点击右上角");

const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "share-desc"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 选择\"浏览器中打开\"");

const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.down_back,
    class: "down-back"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $setup.one,
    class: "mid-img"
  }, null, 8, _hoisted_6), _createElementVNode("img", {
    src: $setup.two,
    class: "mid-white"
  }, null, 8, _hoisted_7), _createElementVNode("img", {
    src: $setup.three,
    class: "mid-img"
  }, null, 8, _hoisted_8)]), _createElementVNode("img", {
    src: $setup.icon,
    class: "app-icon"
  }, null, 8, _hoisted_9), _hoisted_10, !$setup.isIos ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "down-btn btn-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, " 安卓下载 ")) : _createCommentVNode("", true), $setup.isIos ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "down-btn btn-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.openIos && $setup.openIos(...args))
  }, " iOS下载 ")) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "down-btn btn-back",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.toIos && $setup.toIos(...args))
  }, " 登录网页版 ")]), _hoisted_11]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("img", {
    src: $setup.share_point,
    class: "point"
  }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.liulan,
    class: "safari"
  }, null, 8, _hoisted_20))])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_21)) : _createCommentVNode("", true)]);
}